import { reportServices } from '@/services/db'
import { guardClinicalActions } from '@/store/clinical-commit-guard'

const state = {
  chineseReport: [],
}

// getters
const getters = {
  getChineseReport: state => state.chineseReport,
}

// actions
const actions = {
  async fetchChineseReport ({ commit }, payload) {
    try {
      commit('setLoading', true, { root: true })
      const res = await reportServices.fetchChineseReport(payload)
      commit('setChineseReport', res.data)
      commit('setLoading', false, { root: true })
    } catch (e) {
      commit('setLoading', false, { root: true })
    }
  },
}

// mutations
const mutations = {
  clearLicenseRestrictedState (state) {
    state.chineseReport = []
  },
  setChineseReport (state, payload) {
    state.chineseReport = payload
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions: guardClinicalActions(actions),
  mutations
}
